module.exports = __webpack_public_path__ + "img/pc-fee-up.3ce2b793.png";